import { getCarePlanConfig } from 'src/lib/requests';
import { carePlanLoading, getErrorCode } from '../slices';
import { Axios } from 'src/lib';
import { getCarePlanSlice } from '../slices/carePlan.slice';
import { editCarePlanConfig } from 'src/lib/requests/carePlan.url';
import { FronteggContext } from '@frontegg/rest-api';
import { showToastError } from 'src/utilities/errortoast';

// Get Care Plan
export const getCarePlan = (data, navigate) => {
  return async (dispatch) => {
    dispatch(carePlanLoading(true));
    try {
      const { url } = getCarePlanConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(getCarePlanSlice(response?.CarePlan));
        navigate(`/careplan`);
        dispatch(carePlanLoading(false));
      }
    } catch (e) {
      dispatch(getErrorCode(500));
      showToastError('No Care Plan found..');
    }
  };
};

// Edit Care Plan Page

export const editCarePlan = (data) => {
  return async () => {
    carePlanLoading(true);
    try {
      const { url } = editCarePlanConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      await Axios.put(url, data, { headers });
    } catch (e) {
      carePlanLoading(false);
      getErrorCode(500);
    }
  };
};
